import React from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
import { Devices } from '@mui/icons-material';
import DevicesChart from '../charts/DevicesChart';

const SurveyDevices = ({ data, height = null }) => {
    return (
        <Card sx={height ? { height } : undefined}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1,
                    '& .MuiCardHeader-action': {
                        alignSelf: 'center'
                    }
                }}
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Devices />}
                title="Devices"
            />
            <CardContent
                sx={{
                    m: 0,
                    p: 0,
                    '&:last-child': {
                        paddingBottom: 0
                    }
                }}
            >
                {data && data.length > 0 ? (
                    <DevicesChart
                        label="Devices"
                        data={data.filter(e => e.value > 0)}
                    />
                ) : (
                    <Typography variant="body2">No activity</Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default SurveyDevices;